export default "__VITE_ASSET__BTA8LG_e__"